/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-10-13 09:26:27
 * @LastEditors: linxi
 * @LastEditTime: 2021-11-16 13:48:37
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { send } from "../../../app/appSlice"
import { AppThunkApi, RootState } from "../../../app/store"
import {
  excelParams,
  exportExcel,
  getPrisionPage,
  Prison,
  PrisonParams,
} from "../../../services/prison"

interface prisonState {
  prisonList: Prison[]
}

const initialState: prisonState = {
  prisonList: [],
}

// 列表数据
export const getPrisonListAsync = createAsyncThunk<
  Prison[],
  PrisonParams,
  AppThunkApi
>("PrisonList/page", async (params, api) => {
  return send(getPrisionPage(params), api).then((data) => {
    return data.map((v: any) => {
      return {
        ...v,
        organizationTotal: v.acOrgTc,
      }
    })
  })
})
// 导出列表数据
export const exportPrisonListAsync = createAsyncThunk<
  void,
  excelParams,
  AppThunkApi
>("PrisonList/export", async (params, api) => {
  return send(exportExcel(params), api)
})

export const PrisonListSlice = createSlice({
  name: "PrisonListStation",
  initialState,
  reducers: {
    setPrisonList(state, action) {
      state.prisonList = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPrisonListAsync.fulfilled, (state, action: any) => {
      state.prisonList = action.payload
    })
  },
})

export const { setPrisonList } = PrisonListSlice.actions

export const selectPrisonList = (state: RootState) => state.prison.prisonList

export default PrisonListSlice.reducer
